import { tokens } from '@fluentui/react-components';
import { themeVar } from './themeConfig';

export const headingStyle = {
  color: themeVar('heading', 'color', tokens.colorNeutralForeground1),
  letterSpacing: themeVar('heading', 'letterSpacing', 'normal'),
  fontWeight: tokens.fontWeightSemibold,
};

export const headingIconColor = themeVar(
  'heading',
  'iconColor',
  tokens.colorBrandForeground1
);
